import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { scrollToBuy } from './BuyButton';
const images = ['https://cdn.magicpatterns.com/uploads/p4BohrogX23ohueFtojvJz/IMG_2724.jpg', 'https://cdn.magicpatterns.com/uploads/5DgYnBWvHyravAbyXUxz3d/IMG_2730.jpg', 'https://cdn.magicpatterns.com/uploads/fB9sEECsMehSJWs5LRSVG8/IMG_2726.jpg'];
export function WhatsInside() {
  const scrollerRef = useRef<HTMLDivElement>(null);
  const scrollBy = (dir: 1 | -1) => {
    const el = scrollerRef.current;
    if (!el) return;
    const card = el.querySelector<HTMLElement>('[data-card]');
    const w = card ? card.offsetWidth + 16 : el.clientWidth * 0.8;
    el.scrollBy({
      left: dir * w,
      behavior: 'smooth'
    });
  };
  return <section className="w-full py-14 px-4 bg-gradient-to-b from-sky-50/60 to-white" data-id="element-227">
      <div className="max-w-5xl mx-auto" data-id="element-228">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center text-slate-900" data-id="element-229">
          Lo que te vas a encontrar dentro de este pack
        </h2>
        <div className="relative mt-8" data-id="element-230">
          <button onClick={() => scrollBy(-1)} aria-label="Anterior" className="hidden sm:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 z-10 w-11 h-11 rounded-full bg-white border border-slate-200 shadow-md items-center justify-center hover:bg-green-50 hover:border-green-300 transition" data-id="element-231">
            <ChevronLeftIcon className="w-5 h-5 text-slate-700" data-id="element-232" />
          </button>

          <div ref={scrollerRef} className="flex overflow-x-auto gap-4 snap-x-mandatory no-scrollbar pb-4 px-1" data-id="element-233">
            {images.map((src, i) => <button key={i} data-card onClick={scrollToBuy} className="snap-center flex-shrink-0 w-[85%] sm:w-[60%] md:w-[48%] bg-white rounded-2xl border border-slate-200 shadow-md hover:shadow-xl transition-all overflow-hidden group" data-id="element-234">
                <img src={src} alt={`Vista previa ${i + 1} del contenido`} className="w-full h-auto object-cover group-hover:scale-[1.02] transition-transform duration-300" data-id="element-235" />
              </button>)}
          </div>

          <button onClick={() => scrollBy(1)} aria-label="Siguiente" className="hidden sm:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 z-10 w-11 h-11 rounded-full bg-white border border-slate-200 shadow-md items-center justify-center hover:bg-green-50 hover:border-green-300 transition" data-id="element-236">
            <ChevronRightIcon className="w-5 h-5 text-slate-700" data-id="element-237" />
          </button>
        </div>

        <p className="text-center text-xs text-slate-500 mt-2 sm:hidden" data-id="element-238">
          ← Deslizá para ver más →
        </p>
      </div>
    </section>;
}